import { useLayoutEffect, useRef } from 'react';

type RouteTransitionEffect = (currentPath: string, previousPath: string | null) => void;

export const useRouteTransitionEffect = (pathname: string, effect: RouteTransitionEffect): void => {
	const previousPathRef = useRef<string | null>(null);
	const effectRef = useRef<RouteTransitionEffect>(effect);

	useLayoutEffect(() => {
		effectRef.current = effect;
	}, [effect]);

	useLayoutEffect(() => {
		const previousPath = previousPathRef.current;
		previousPathRef.current = pathname;
		effectRef.current(pathname, previousPath);
	}, [pathname]);
};
